<template>
  <div
    class="bio-editor-header d-flex justify-content-between border-bottom pb-3"
  >
    <div class="bio-link">
      <div class="text-truncate">
        <span class="c-charcoal">
          {{ $t('SETTINGS.TITLE.MARVELOUS_BIO').toLowerCase() }}
        </span>
        <span>/{{ teacher.studio_url }}</span>
      </div>
      <span class="d-inline ml-2 ml-md-3 h3 mt-2" @click="copy">
        <i class="far fa-copy c-coral pointer"></i>
      </span>
    </div>
    <DepletingAudioIcon :bio="bio" v-on="$listeners" />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import DepletingAudioIcon from '@/web/components/bio/DepletingAudioIcon.vue';

export default Vue.extend({
  name: 'BioEditorHeader',
  components: {
    DepletingAudioIcon,
  },
  props: {
    bio: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      teacher: 'user/teacher',
    }),
    audioUrl() {
      return this.bio?.audio?.storage_url;
    },
  },
  methods: {
    copy() {
      const hostName =
        process.env.VUE_APP_MARVELOUS_BIO_URL || 'https://marvelous.bio';
      const link = `${hostName}/${this.teacher.studio_url}`;
      this.$copyText(link).then(() => {
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('BIO.TEXT.MARVELOUS_BIO_LINK_COPIED_TO_CLIPBOARD'),
        });
      });
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.bio-link {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
  font-size: 20px;
  max-width: calc(100% - 60px);
  @include media-breakpoint-up(md) {
    font-size: 36px;
    max-width: auto;
  }
}

.bio-link-truncate {
  max-width: calc(100% - 200px);
}
</style>
